import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CheckComponent } from './stappen/check/check.component';
import { TipsComponent } from './stappen/tips/tips.component';
import { OverzichtComponent } from './stappen/overzicht/overzicht.component';
import { ErrorschermComponent } from './stappen/error/errorscherm.component';
import { SessieVerlopenComponent } from './stappen/sessie-verlopen/sessie-verlopen.component';

type PathMatch = "full" | "prefix" | undefined;

const routes: Routes = [
  { path: '', redirectTo: 'intro', pathMatch: 'full' as PathMatch},
  { path: 'intro', component: OverzichtComponent },
  { path: 'check', component: CheckComponent },
  { path: 'tips', component: TipsComponent },
  { path: 'error', component: ErrorschermComponent },
  { path: 'sessie-verlopen', component: SessieVerlopenComponent },
  { path: '**', redirectTo: 'intro' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
